// module imports
import { contactSource, numberFromContact } from 'modules/Contact'
import {
  initialsFromString,
  isSvgString,
  svgImageSource,
} from 'modules/Helpers'
import { parkedSlot2extension } from 'modules/ParkingSlot'
import { numberOrNameFromContactSimple } from '../Contact'

// list of ids that have had their svgs sent
export const svgList = []
/**
 * Either returns
 * 1. url
 * 2. svg string if first time sending
 * 3. 'SVG_SENT if svg already sent
 *
 * @param participant
 * @param id
 * @returns {string}
 */
const getAvatar = (participant, id) => {
  const { avatar, name } = participant
  // if not avatar try to create initials
  if (!avatar) {
    return initialsFromString(name)
  }

  // svg
  if (isSvgString(avatar)) {
    if (svgList.includes(id)) {
      return 'SVG_SENT'
    }
    svgList.push(id)

    return svgImageSource(avatar)
  }

  // url
  return avatar
}

const getDestination = (contact, incoming) => {
  if (incoming || contact.wasParked) return contactSource(contact, true)

  return numberFromContact(contact)
}

export const summary = (session, includeAvatar) => {
  const {
    id,
    incoming,
    hold,
    startTime,
    participant,
    warmTransferring,
    merged,
  } = session

  const origin = numberOrNameFromContactSimple(participant)
  let destination = getDestination(participant, incoming)
  if (origin === destination) {
    destination = ''
  }

  return {
    id,
    incoming,
    hold,
    startTime,
    origin,
    destination,
    merged,
    avatar: includeAvatar ? getAvatar(participant, id) : '',
    avatarType: participant.type,
    warmTransfer: !!warmTransferring,
    wasParked: !!participant.wasParked,
  }
}

export const parkedSummary = (session, slot) => {
  const id = parkedSlot2extension(slot)
  return {
    summary: {
      ...summary(session),
      id,
      park: true,
      slot,
    },
    id,
    participant: session.participant,
  }
}
